import React, { useEffect, useRef, useState } from "react"
import { Container } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import JsPDF from "jspdf"
import { Row, Modal, Form, Canvas } from "reactstrap"
// canvas
import SignatureCanvas from "react-signature-canvas"
 
// images
import zithasLogo from "../../../../assets/images/zithas-dark-logo.png"
import sign from "../../../../assets/images/signature.png"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import swal from "sweetalert"
import configure from "configure"
import Swal from "sweetalert2"
import html2pdf from "html2pdf.js"
import { useReactToPrint } from "react-to-print"
import { FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { onDownloadPdf } from "utils/common-helpers"
 
const GeneratedContract = () => {
  const [fixedRightSec, setFixedRightSec] = useState(false)
  const [modal_center, setmodal_center] = useState(false)
 
  document.addEventListener("scroll", () => {
    if (window.scrollY > 48) {
      setFixedRightSec(true)
    } else {
      setFixedRightSec(false)
    }
  })
 
  const contentRef = useRef(null)
  const reactToPrintFn = useReactToPrint({
    contentRef,
  })
 
  const printContract = () => {
    let printContents = document.getElementById("zithasInvoicePrint").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print()
    document.body.innerHTML = originalContents
  }
 
  const generatePDF = () => {
    const contract = new JsPDF("portrait", "pt", "a3")
    contract.html(document.querySelector("#zithasInvoicePrint")).then(() => {
      contract.save("zithasContract.pdf")
    })
  }
  const params = useParams()
  const [isLoading, setLoading] = useState(false)
  const [description, setDescription] = useState("")
  const [date, setDate] = useState("")
  const [template_name, setTemplateName] = useState("")
  const [expire, setExpire] = useState()
  const [introducer_id, setIntroducerId] = useState()
 
  useEffect(() => {
    fetchContract()
  }, [])
 
  const fetchContract = async () => {
    setLoading(true)
    const formData = new FormData()
    // junk_link can contain "#", which the browser treats as the URL fragment,
    // so links shared before encoding was added arrive split across id + hash
    formData.append("junk_link", `${params.id || ""}${window.location.hash || ""}`)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/show_introducer_contract`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(response => {
        if (response.data.success == true) {
          setExpire(false)
          setDescription(response.data.data[0]?.description)
          setDate(response.data.data[0]?.created_at)
          setTemplateName(response.data.data[0]?.template_name)
          setContractId(response.data.data[0]?.id)
          setIntroducerId(response.data.data[0]?.introducer_id)
        } else {
          setExpire(true)
        }
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
 
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [contract_id, setContractId] = useState()
  const [modal_doc, setmodal_doc] = useState(false)
 
  const signatureRef = useRef(null)
  const [signature, setSignature] = useState("")
  const [sign_name, setSignName] = useState("")
 
  const handleSave = async e => {
    e.preventDefault()
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      Swal.fire({
        icon: "warning",
        text: "Please Sign the contract",
      })
      return
    }
    const signatureImage = signatureRef.current.toDataURL()
    setLoading(true)
    const formData = new FormData()
    formData.append("contract_id", contract_id)
    formData.append("name", name)
    formData.append("email", email)
    formData.append("signature", signatureImage)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/save_introducer_signature`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        swal({
          icon: "success",
          text: "Thanks For signining Contract",
        }).then(data => {
          setmodal_center(false)
          setSignature(response.data.data[0].signature)
          setSignName(response.data.data[0].name)
        })
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
 
  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }
 
  const [attachment, setAttachment] = useState(null)
 
  const handleAttachmentSave = async e => {
    e.preventDefault()
 
    if (!attachment) {
      Swal.fire({
        icon: "warning",
        text: "Please add the contract",
      })
      return
    }
 
    setLoading(true)
    const formData = new FormData()
 
    formData.append("name", name)
    formData.append("email", email)
    formData.append("introducer_id", introducer_id)
    formData.append("contract_id", contract_id)
    formData.append("attachment", attachment)
 
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/introducerConAttachment`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
 
      swal({
        icon: "success",
        text: "Thanks For signing Contract",
      }).then(() => {
        setmodal_doc(false)
        setExpire(true)
      })
    } catch (err) {
      setLoading(false)
 
      if (err?.response?.data?.message) {
        Swal.fire({
          icon: "error",
          text: err.response.data.message,
        })
      } else {
        Swal.fire({
          icon: "error",
          text: "Something went wrong!",
        })
      }
 
      console.log(err)
    }
  }
 
  const handleClear = () => {
    signatureRef.current.clear()
  }
 
  if (expire == false) {
    return (
      <React.Fragment>
        {isLoading && <Loader />}
        <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
          <Container fluid>
            <Row>
              <div className="col-md-9 ps-0">
                <div
                  id="zithasInvoicePrint"
                  ref={contentRef}
                  className="bg-white p-3 px-5 shadow document"
                >
                  <div className="pb-2 text-center">
                    <img src={zithasLogo} height="60" alt="zithasLogo" />
                  </div>
                  <div>
                    <h5 className="text-center mt-4 mb-4 fw-bold"></h5>
 
                    <div>
                      <div
                        style={{ textAlign: "justify" }}
                        className="Features"
                        dangerouslySetInnerHTML={{
                          __html: description,
                        }}
                      />
                    </div>
 
                    <h5 className="fw-bold text-decoration-underline">
                      Date : {moment(date).format("DD-MM-YYYY")}
                    </h5>
 
                    <Row className="mt-4 justify-space-between">
                      <div className="col-4">
                        {sign_name?.length != 0 ? (
                          <img src={sign} height="50" className="mb-2" />
                        ) : (
                          <div className="sign-box">Signature</div>
                        )}
 
                        <h5>Zithas Signature</h5>
                      </div>
                      <div className="col-4">
                        <img src={signature} height="50" className="mb-2" />
                        <h5>{sign_name}</h5>
                      </div>
                    </Row>
                  </div>
                </div>
              </div>
 
              <div className="col-md-3 pe-0 ">
                <div
                  className={`${
                    fixedRightSec ? "fixed-right-section top-0 " : ""
                  }`}
                >
                  <div className="col-12 text-start ">
                    <button
                      onClick={() => reactToPrintFn()}
                      className="btn btn-sm btn-success border-radius me-1"
                    >
                      <i className="fas fa-print me-1"></i> Print
                    </button>
                    {sign_name?.length == 0 ? (
                      <button
                        onClick={() => setmodal_center(true)}
                        className="btn btn-sm btn-primary border-radius me-1"
                      >
                        <i className="fas fa-file-signature me-1"></i> Signature
                      </button>
                    ) : null}
 
                    <button
                      onClick={() => {
                        console.log("download clicked")
                        onDownloadPdf(setLoading, contentRef, "contract")
                      }}
                      className="btn btn-sm btn-secondary border-radius"
                    >
                      <i className="fas fa-file-download me-1"></i> Downloads
                    </button>
                  </div>
 
                  <div className="bg-white p-3 mt-4 shadow ">
                    <p className="text-danger">
                      * If you encounter any issues while signing the contract,
                      please print it, sign it manually, and upload the signed
                      contract here.
                    </p>
 
                    <div>
                      {/* <label htmlFor="">Attachment</label> */}
                      <Row className="align-items-center col-md-12">
                        <button
                          title="upload"
                          className="btn btn-secondary border-radius"
                          onClick={() => setmodal_doc(true)}
                        >
                          <i className="fas fa-upload"></i>
                          <span> upload you signed Contract</span>
                        </button>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </Container>
        </div>
 
        {/* Signature Modal */}
        <Modal
          isOpen={modal_center}
          toggle={() => {
            tog_center()
          }}
          centered
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              Signature & Confirmation Of Identity
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_center(false)
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSave}>
              <Row>
                <div className="col-5 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control border-radius"
                    onChange={e => setName(e.target.value)}
                  />
                </div>
                <div className="col-5 mb-3">
                  <label htmlFor="">Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control border-radius"
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">Signature</label>
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      width: 760,
                      height: 300,
                      className: "sigCanvas border ",
                    }}
                    ref={signatureRef}
                  />
                </div>
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <a
                  className="btn btn-red border-radius me-2"
                  onClick={handleClear}
                >
                  Clear Signature
                </a>
                <button className="btn btn-purple border-radius">Submit</button>
              </div>
            </Form>
          </div>
        </Modal>
        {/* ------------ */}
 
        <Modal
          isOpen={modal_doc}
          toggle={() => {
            tog_center()
          }}
          centered
          size="md"
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Upload Your Signed Contract</h5>
            <button
              type="button"
              onClick={() => {
                setmodal_doc(false)
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleAttachmentSave}>
              <Row>
                <div className="col-5 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control border-radius"
                    onChange={e => setName(e.target.value)}
                  />
                </div>
                <div className="col-7 mb-3">
                  <label htmlFor="">Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control border-radius"
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label>Attachment</label>
                  <input
                    id="attachment"
                    type="file"
                    className="form-control border-radius"
                    onChange={e => setAttachment(e.target.files[0])}
                  />
                </div>
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <button className="btn btn-purple border-radius">Submit</button>
              </div>
            </Form>
          </div>
        </Modal>
      </React.Fragment>
    )
  } else if (expire == true) {
    return (
      <section className="my-5 pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center col">
              <div className="home-wrapper">
                <div className="mb-5">
                  <a className="d-block auth-logo" href="/dashboard"></a>
                </div>
                <div className="justify-content-center row">
                  <div className="col-sm-4">
                    <div className="maintenance-img">
                      <img
                        src="/static/media/maintenance.938d28ce46a03edf5d9303e67f1d2028.svg"
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
 
                <h1 className="mt-5 pt-5">Thanks For signing Contract</h1>
                <h5 className="mt-2">We'll get in contact with you shortly </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return <Loader />
  }
}
 
export default GeneratedContract